import { gql } from '@apollo/client'

export const SHOP_SQUARE_CUSTOMER_CARD_FRAGMENT = gql`
  fragment ShopSquareCustomerCard on ShopSquareCustomerCard {
    id
    cardBrand
    cardholderName
    expMonth
    expYear
    last4
    primary
  }
`
